import { useCallback, useContext } from "react";
import { AuthContext } from "react-oauth2-code-pkce";

const useAuth = () => {
  const { logOut, ...rest } = useContext(AuthContext);

  const handleLogOut = useCallback(() => {
    logOut(undefined, undefined, { returnUrl: window.location.origin });
  }, [logOut]);

  const auth = { ...rest, logOut: handleLogOut };

  if (!auth) {
    throw new Error("useAuth must be used inside the AuthProvider from react-oauth2-code-pkce");
  }

  return auth;
};

export default useAuth;
